const bundle = {
  close: () => '閉じる',
  error: () => 'エラー',
  warn: () => '警告',
  info: () => '情報',
  confirmation: () => '確認',
  progressIndeterminate: () => '進行中',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    p['FROM_SECTION'] + 'から' + p['TO_SECTION'] + 'まで。',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '。一致するセクションが見つかりませんでした。',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => '[Enter]を押して値を選択します。',
  indexer_touchInstructionText: () =>
    'ダブル・タップしてホールドし、ジェスチャ・モードを開始した後、上下にドラッグして値を調整します。',
  inputPassword_show: () => 'パスワードの表示',
  inputPassword_hide: () => 'パスワードの非表示',
  inputPassword_hidden: () => 'パスワード非表示',
  formControl_clear: () => 'クリア',
  formControl_loading: () => 'ロード中',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    '最大長' + p['MAX_LENGTH'] + 'を超えています。',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + '文字残っています。',
  select_noMatchesFound: () => '一致する検索文字列が見つかりませんでした。',
  select_oneMatchFound: () => '一致が1つ見つかりました',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + '件の一致が見つかりました',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + '件以上の一致が見つかりました',
  selectMultiple_showSelectedValues: () => '選択された値のみを表示します。',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + '個の値が選択されました。',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selector_selected: () => 'チェック・ボックス(選択済)',
  selector_unselected: () => 'チェック・ボックス(未選択)',
  userAssistance_learnMore: () => 'さらに学ぶ',
  userAssistance_required: () => '必須',
  filePicker_singleFileUploadError: () => '一度に1つのファイルをアップロードします',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'タイプが' + p['fileType'] + 'のファイルはアップロードできません',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    '次のタイプのファイルはアップロードできません: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => '不明',
  filePicker_dropzonePrimaryText: () => 'ドラッグ・アンド・ドロップ',
  filePicker_dropzoneSecondaryText: () => 'ファイルを選択するか、ここにドロップします',
  filePicker_dropzoneSecondaryTextMultiple: () => 'ファイルを選択するか、ここにドロップします',
  filePicker_addFiles: () => 'ファイルの追加',
  plural_separator: () => ', ',
  inputNumber_increase: () => '増やす',
  inputNumber_decrease: () => '減らす',
  inputNumber_converterParseError: () => 'Enter a number.',
  noData_message: () => '表示するアイテムはありません',
  message_navigationFromMessagesRegion: () =>
    'メッセージ・リージョンに入ります。フォーカスされていた前の要素に戻るには、[F6]を押してください。',
  message_navigationToMessagesRegion: () =>
    'メッセージ・リージョンに新しいメッセージがあります。最新のメッセージ・リージョンに移動するには、[F6]を押してください。',
  messageToast_allMessagesClosed: () => 'すべての通知メッセージが閉じられています。'
};
export default bundle;
